import { observer } from 'mobx-react-lite';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_ThemeStore } from './ThemeStore';

export const ThemeToggleView = observer(function ThemeToggleView() {
  const store = useResolve(TOKEN_ThemeStore);
  return (
    <button
      type="button"
      onClick={store.toggle}
      className="rounded border border-slate-300 px-2 py-1 text-xs text-slate-700 hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
      title="Toggle theme (press d)"
    >
      {store.isDark ? '☾ dark' : '☀ light'}
    </button>
  );
});
